import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { toast } from 'react-toastify'
import { Button } from 'src/components'
import { useStyles } from './styles'
import ROUTES from 'src/constants/routes'
import { VALIDATIONS } from 'src/@types/validations'
import { useChangePassword } from 'src/hooks/api/user'
import { ChangePasswordDto } from 'src/dto/user.dto'
import { useAuth } from 'src/contexts/auth'

interface ChangePasswordFormData {
  senha: string
  confirmSenha: string
  username: string
  adminUsername: string
}

export const ChangePassword: React.FC = () => {
  const style = useStyles()
  const navigate = useNavigate()
  const { logout, username } = useAuth()

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm<ChangePasswordFormData>({
    resolver: yupResolver(VALIDATIONS.User.changePasswordSchema),
    defaultValues: {
      username,
      adminUsername: username,
      senha: '',
      confirmSenha: ''
    }
  })

  useEffect(() => {
    if (!username) return
    setValue('username', username)
    setValue('adminUsername', username)
  }, [username])

  const { mutate: changePassword, isPending } = useChangePassword()

  const onSubmit = (data: ChangePasswordFormData) => {
    if (!username) {
      toast.error('Usuário não encontrado. Faça login novamente.')
      navigate(ROUTES.AUTH.LOGIN)
      return
    }

    const payload: ChangePasswordDto = {
      username,
      adminUsername: username,
      senha: data.senha
    }

    changePassword(payload, {
      onSuccess: () => {
        console.log('Password changed successfully')
        toast.success('Senha alterada com sucesso! Faça login novamente.')
        setTimeout(() => {
          logout()
        }, 2000)
      },
      onError: (error: any) => {
        console.error('Erro ao trocar senha:', error)
        toast.error(error?.response?.data?.message || 'Erro ao trocar senha. Tente novamente.')
      }
    })
  }

  return (
    <div className={style.changePasswordContainer}>
      <div className={style.changePasswordForm}>
        <div className={style.changePasswordTitleWrapper}>
          <h1>CONGADO</h1>
        </div>

        <div className={style.changePasswordInfoWrapper}>
          <h2>Trocar senha</h2>
          <p className={style.changePasswordDescription}>Antes de prosseguir, é necessário trocar a sua senha.</p>
        </div>

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className={style.changePasswordInput}>
            <label>Nova Senha</label>
            <input
              id='change-password__senha'
              type='password'
              placeholder='Digite sua nova senha'
              disabled={isPending}
              {...register('senha')}
            />
            {errors.senha && <span className={style.changePasswordError}>{errors.senha.message}</span>}
          </div>

          <div className={style.changePasswordInput}>
            <label>Confirmar Senha</label>
            <input
              id='change-password__confirmSenha'
              type='password'
              placeholder='Confirme sua nova senha'
              disabled={isPending}
              {...register('confirmSenha')}
            />
            {errors.confirmSenha && <span className={style.changePasswordError}>{errors.confirmSenha.message}</span>}
          </div>

          <div className={style.changePasswordButtons}>
            <Button type='submit' className='change-password__button' isLoading={isPending} disabled={isPending}>
              Confirmar
            </Button>
          </div>
        </form>
      </div>

      <div className={style.changePasswordImageSide}></div>
    </div>
  )
}
